export default "__VITE_ASSET__CrI__NkZ__"